import { h } from "./../../utils/createElement";
import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { consumeTheme } from '../../utils/theme';
var Button = (function (_super) {
    __extends(Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style = _b.style, type = _b.type, size = _b.size, disabled = _b.disabled, testId = _b.testId, rest = __rest(_b, ["prefixCls", "className", "style", "type", "size", "disabled", "testId"]);
            var classes = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-type-" + type] = type,
                _a[prefixCls + "-size-" + size] = size,
                _a[prefixCls + "-disabled"] = disabled,
                _a));
            return (h("button", __assign({}, rest, { className: classes, style: style, disabled: disabled, "data-testid": testId }), _this.props.children));
        };
        return _this;
    }
    Button.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Button;
}(React.Component));
export default Button;
Button.defaultProps = {
    prefixCls: 'dui-m-button',
    type: 'default',
    size: 'default'
};
